import { useRouter } from 'next/navigation'
import { useSetRecoilState } from 'recoil'

import { dialogState } from '@/components/Context/DialogProvider'
import { useEvent } from '@/components/hooks/useRecordEvent'
import { addCart } from '@/serverActions/addCart'

export type CartPageType = 'market' | 'crm'

export const useAddCart = ({
  productId,
  productIds,
  campaignId = null,
  cartVersion = 'new',
  cartPageType = 'market',
  extra = {},
  afterSubmit = null,
}: {
  productId?: string
  productIds?: string[]
  campaignId?: string | null
  cartVersion?: 'new' | 'exist'
  cartPageType?: string
  extra?: Record<string, string | any[]>
  afterSubmit?: null | (() => void)
}) => {
  const { record } = useEvent()
  const setDialog = useSetRecoilState(dialogState)
  const router = useRouter()
  const click = async (impressionId: string | null): Promise<void> => {
    record('add_cart', {
      productId,
      version: 1,
      ...extra,
    })

    const response = await addCart({
      quantity: 1,
      purchaseType: 'once',
      cartVersion,
      ...(productIds ? { productIds } : productId ? { productId } : {}),
      ...(impressionId ? { impressionId } : {}),
      ...(campaignId ? { campaignId } : {}),
    })

    if (response.success) {
      if (afterSubmit != null) {
        afterSubmit()
      } else {
        router.push(`/${cartPageType}-carts`)
      }
    } else {
      const errors = response.errors
      if (errors?.message != null) {
        if (errors?.dialog != null) {
          setDialog({
            message: errors.message!,
            title: errors.dialog.title,
            href: errors.dialog.href,
            buttonText: errors.dialog.buttonText,
          })
        } else {
          alert(errors.message)
        }
      } else {
        alert('カートに追加できませんでした。')
      }
    }
  }

  return {
    click,
  }
}
